export default function truncate(text, stop, clamp) {
  return text.slice(0, stop).trim() + (stop < text.length ? clamp || '...' : '')
}
